import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminCertifications } from '@/api/(admin)/certifications';
import type { AdminCertificationsQueryInput } from '@/api/(admin)/certifications/types';
import {
  buildAdminCertificationsQs,
  toAdminCertificationsParams,
} from '../-utils/listParams';

/**
 * Shared by the route loader and the component's hook, keyed on the
 * *converted* params so both land on one cache entry.
 */
export function adminCertificationsQueryOptions(
  input: AdminCertificationsQueryInput,
) {
  const params = toAdminCertificationsParams(input);
  return queryOptions({
    queryKey: ['admin', 'claims', 'list', params] as const,
    queryFn: () => fetchAdminCertifications(buildAdminCertificationsQs(params)),
    staleTime: 60_000,
  });
}

/** Everything under this prefix — what the bulk actions invalidate. */
export const adminCertificationsQueryKey = ['admin', 'claims'] as const;

export function useAdminCertifications(input: AdminCertificationsQueryInput) {
  const query = useQuery(adminCertificationsQueryOptions(input));

  return {
    ...query,
    rows: query.data?.data ?? [],
    totalCount: query.data?.metadata?.pagination?.total ?? 0,
  };
}
